import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import MydataModal from "../mydata/modalForMydata/mydatamodal";

export default function EditMyProfile() {
    const modalRef = useRef()
    const navigate = useNavigate()
    const myinfos = useSelector(data=> data.getMyImageReducer);
    const myinfo = useSelector(data=> data.getMayInfoReducer.myinfo)
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
// btn.onclick = function() {
//   modal.style.display = "block";
// }

// // When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}


const modclose=()=>{
    modal.style.display = "none";
}

    return (
            <>
                      <div className="headerInfo" >
          <div className="child1">
                <button className="backbtn" onClick={modclose}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M4.79381 12.4788L11.2682 19.5366C11.7914 20.1534 11.7156 21.0776 11.0989 21.6008C10.4821 22.1241 9.5579 22.0482 9.03467 21.4315L0.424939 12.0458C0.301135 11.9214 0.200811 11.7757 0.128799 11.6157C0.039247 11.4167 -0.00462998 11.2002 0.000386447 10.9821L0.000407932 10.9808C0.00539306 10.7631 0.0587076 10.5493 0.156492 10.3548C0.166001 10.336 0.175914 10.3174 0.186226 10.299C0.245899 10.1922 0.318821 10.0934 0.403261 10.0049L9.24191 0.468963C9.79174 -0.124242 10.7183 -0.159391 11.3115 0.390416C11.9047 0.940222 11.9399 1.86684 11.3901 2.46003L4.81875 9.54979H20.5122C21.3211 9.54979 21.9767 10.2055 21.9767 11.0143C21.9767 11.8231 21.3211 12.4788 20.5122 12.4788H4.79381V12.4788Z" fill="#3B79F6"/>
                  </svg>
                </button>
                        {
                          myinfos.users.myavatar?
                          <img src={myinfos.users.myavatar} alt="" />
                          :
                          <svg xmlns="http://www.w3.org/2000/svg" width="156" height="156" viewBox="0 0 156 156" fill="none">
                          <path opacity="0.4" d="M78 156C121.078 156 156 121.079 156 77.9999C156 34.9218 121.078 0 78 0C34.9218 0 0 34.9218 0 77.9999C0 121.079 34.9218 156 78 156Z" fill="#A3A3A3"/>
                          <path d="M78 38.4531C61.854 38.4531 48.75 51.5571 48.75 67.7028C48.75 83.5368 61.152 96.4068 77.61 96.8748C77.844 96.8748 78.156 96.8748 78.312 96.8748C78.468 96.8748 78.702 96.8748 78.858 96.8748C78.936 96.8748 79.014 96.8748 79.014 96.8748C94.77 96.3288 107.172 83.5368 107.25 67.7028C107.25 51.5571 94.146 38.4531 78 38.4531Z" fill="#1B1B1B"/>
                          <path d="M130.889 135.33C117.005 148.122 98.4415 156 78.0055 156C57.5695 156 39.0055 148.122 25.1215 135.33C26.9935 128.232 32.0635 121.758 39.4735 116.766C60.7675 102.57 95.3995 102.57 116.537 116.766C124.025 121.758 129.017 128.232 130.889 135.33Z" fill="#1B1B1B"/>
                        </svg>
                        }
              
                  {/* <button className="editBtnProfile"  >
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M13.5159 7.35778L14.6402 8.48222L3.56839 19.5556H2.44411V18.4311L13.5159 7.35778ZM17.9153 0C17.6098 0 17.292 0.122222 17.0599 0.354444L14.8235 2.59111L19.4062 7.17444L21.6425 4.93778C22.1192 4.46111 22.1192 3.69111 21.6425 3.21444L18.7829 0.354444C18.5385 0.11 18.233 0 17.9153 0ZM13.5159 3.89889L0 17.4167V22H4.5827L18.0986 8.48222L13.5159 3.89889Z" fill="#3B79F6"/>
                    </svg>
                  </button> */}
                  <MydataModal data={myinfo}/>
          </div>
          <h1>{myinfos.users.data&&myinfos.users.data.name}</h1>
          
          
        </div>
      <div className="editOnfo" style={{marginBottom:"10px"}}>
      <label htmlFor="">
        Электронная почта
            <input placeholder='NadyaIsaev@gmail.com' value={myinfos.users.data&&myinfos.users.data.email} disabled/>
        </label>
        <label htmlFor="">
        Номер телефона
        <input placeholder='+79230189837'  value={myinfos.users.data&&myinfos.users.data.tel} disabled />
        </label>
        <label htmlFor="">
        Telegram
        <input placeholder='@uprosti.rf'  value={myinfos.users.data&&myinfos.users.data.telegram} disabled />
        </label>
        <label htmlFor="">
        WhatsApp
        <input placeholder='+79000000000' disabled  value={myinfos.users.data&&myinfos.users.data.whatsUp} />
        </label>
      </div>
            </>
    )
}